import { FunctionComponent } from 'react'
import CreationToolGradient from './gradient'
import { CheckIcon, ErrorIcon, Props, ClockIcon } from '../components/upload/list/icons'

/**
 * Super Cut capture status details.
 */
enum SuperCutStatus {
    InProgress = 'CT_SUPER_CUT_STATUS_IN_PROGRESS',
    Pending = 'CT_SUPER_CUT_STATUS_PENDING',
    Error = 'CT_SUPER_CUT_STATUS_ERROR',
    Done = 'CT_SUPER_CUT_STATUS_DONE',
}

namespace SuperCutStatus {
    /**
     * Returns a normalized status constant since dvr-app returns a charfield.
     */
    export function getNormalizedStatus(status: string): SuperCutStatus {
        switch (status.toLowerCase()) {
            case 'in_progress':
                return SuperCutStatus.InProgress
            case 'queued':
            case 'preparing':
                return SuperCutStatus.Pending
            case 'error':
                return SuperCutStatus.Error
            case 'done':
                return SuperCutStatus.Done
            default:
                return SuperCutStatus.Error
        }
    }

    /**
     * Returns the status' text for display.
     */
    export function title(status: SuperCutStatus): string {
        switch (status) {
            case SuperCutStatus.InProgress:
                return 'In Progress'
            case SuperCutStatus.Pending:
                return 'Pending'
            case SuperCutStatus.Error:
                return 'Error'
            case SuperCutStatus.Done:
                return 'Done'
        }
    }

    /**
     * Returns the color gradient for a status pill.
     */
    export function gradient(status: SuperCutStatus): string[] {
        switch (status) {
            case SuperCutStatus.Pending:
            case SuperCutStatus.InProgress:
                return CreationToolGradient.colors(CreationToolGradient.OrangeYellow)
            case SuperCutStatus.Error:
                return CreationToolGradient.colors(CreationToolGradient.PurpleRed)
            case SuperCutStatus.Done:
                return CreationToolGradient.colors(CreationToolGradient.BlueGreen)
        }
    }

    export function icon(status: SuperCutStatus): FunctionComponent<Props> {
        switch (status) {
            case SuperCutStatus.Pending:
            case SuperCutStatus.InProgress:
                return ClockIcon
            case SuperCutStatus.Error:
                return ErrorIcon
            case SuperCutStatus.Done:
                return CheckIcon
        }
    }
}

export default SuperCutStatus
